export const http = {

  /**
   * This fetch wrapper abstracts retrieving and injecting the auth token.
   *
   * @param url
   * @param options Fetch options headers, methods etc.
   * @returns {Promise<unknown>}
   */
  fetch: function (url, options) {

    const requestOptions = {
      method: 'GET',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' }
    }

    return window.fetch(`${process.env.VUE_APP_API_URL}/refresh`, requestOptions)
            .then(response => {
              if(response.status !== 200){
                window.location = `${process.env.VUE_APP_CF_BASE}/logout`
              }
              return response.text()
            })
            .then(token => {
              token = JSON.parse(token)

              let requestOptions = { ...options }

              requestOptions.headers = {
                ...requestOptions.headers,
                Authorization: `Bearer ${token}`,
              }

              return window.fetch(url, requestOptions)
            }).catch(error => {
              return error
            })
  }
}
